export const TYPE_LABELS = {
  detener:  "🛑 Detener",
  prevenir: "🛡 Prevenir",
  mitigar:  "⚠ Mitigar",
};

export const TIMEFRAME_LABELS = {
  corto: "Corto (3.1.1)",
  largo: "Largo (3.1.2)",
};

export const COMPONENT_LABELS = {
  politicas:     "Políticas",
  capacitacion:  "Capacitación",
  instalaciones: "Mejora instalaciones",
  sistemas:      "Sistemas de gestión",
  derechos:      "Derechos trabajadores",
};

export const STATUS_LABELS = {
  planificado: "📅 Planificado",
  curso:       "⚙ En curso",
  completado:  "✓ Completado",
  pospuesto:   "⏸ Pospuesto",
};

export const STATUS_PILL = {
  planificado: "muted",
  curso:       "b",
  completado:  "g",
  pospuesto:   "y",
};

export const SEVERITY_LABELS = {
  bajo:    "Bajo (1–5)",
  medio:   "Medio (6–10)",
  alto:    "Alto (11–15)",
  critico: "Crítico (16–25)",
};

export const CAP_DEFAULT = [
  { id:"CAP-2026-005", site:"ba",   title:"Política y revisión de salarios contra Anker living wage benchmark", originType:"risk", originRef:"r8", context:"Risk Register: salarios vivibles significance 13.33 (alto) en BA. Inflación argentina.", type:"mitigar", timeframe:"largo", component:"politicas", severity:"alto", c1:true, c2:true, c3:true, c4:true, responsible:"Director Compensaciones LATAM + CFO", deadline:"2026-12-15", resources:"USD 0 política · USD 280k/año en banda", indicator:"% personal por encima de Anker AR · 100%", stakeholders:"Sindicato UTHGRA-AOT, comisión interna", progress:30, status:"curso", evidence:"Anker AR 2026 calculado. 18% del personal debajo.", notes:"Negociación con sindicato." },
  { id:"CAP-2026-008", site:"ba",   title:"Integrar costos de trabajo decente en modelo FOB", originType:"gap", originRef:"d2", context:"Autoevaluación 2.2: Compra & precios madurez 2 en BA. OCDE Recuadro 4.", type:"prevenir", timeframe:"largo", component:"sistemas", severity:"alto", c1:true, c2:true, c3:true, c4:true, responsible:"Director Compras LATAM + CFO", deadline:"2026-10-31", resources:"USD 18,000 · consultoría", indicator:"% líneas con FOB que incluye trabajo decente · 100%", stakeholders:"Compras, finanzas, proveedores tier 1", progress:15, status:"curso", evidence:"TdR redactado. RFQ a 3 firmas.", notes:"Kickoff Q2 2026." },
  { id:"CAP-2026-012", site:"ba",   title:"Capacitación específica para compras y comex en riesgos OCDE", originType:"gap", originRef:"d5", context:"Autoevaluación 2.2: Entrenamientos madurez 4 BA pero falta cobertura para compras y comex.", type:"prevenir", timeframe:"largo", component:"capacitacion", severity:"medio", c1:true, c2:true, c3:true, c4:true, responsible:"Directora L&D + Director Compras LATAM", deadline:"2026-07-31", resources:"USD 8,000 · e-learning + workshop", indicator:"% equipos capacitados · examen aprobado", stakeholders:"Compras, comex, finanzas", progress:55, status:"curso", evidence:"E-learning desarrollado. 22 de 38 en módulo 1.", notes:"Workshop mayo 2026." },
];

export function daysUntil(dateStr) {
  if (!dateStr) return null;
  return Math.ceil((new Date(dateStr).getTime() - new Date().getTime()) / 86400000);
}

export function progressClass(p, status) {
  if (status === "completado" || p >= 100) return "done";
  if (p >= 67) return "hi";
  if (p >= 34) return "mid";
  return "lo";
}

